import * as React from "react";
import type { SVGProps } from "react";
const SvgSpsxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="spsx_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192h603.52a42.667 42.667 0 1 0 0-85.334h-603.52A149.419 149.419 0 0 0 192 362.667z"
    />
  </svg>
);
export default SvgSpsxIcon;
